export default __webpack_public_path__ + "static/ashley-6473e81469f065c050a60b05e0b08878.jpg";